import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.3094 4.69055H6.85713V3.08104C6.85713 2.56822 6.44138 2.15247 5.92857 2.15247C5.41575 2.15247 5 2.56822 5 3.08104V32.919C5 33.4318 5.41575 33.8475 5.92857 33.8475C6.44138 33.8475 6.85713 33.4318 6.85713 32.919V18.9286H18.3094C18.8222 18.9286 19.2379 18.5128 19.2379 18V5.61912C19.2379 5.1063 18.8222 4.69055 18.3094 4.69055Z",
      fill: "#FFE400"
    }, null, -1),
    _createElementVNode("path", {
      d: "M30.9335 20.7504L28.5954 14.9048L30.9335 9.05915C31.0481 8.77315 31.0128 8.44877 30.8401 8.19372C30.6673 7.93868 30.3795 7.78577 30.0712 7.78577H21.0951V18C21.0951 19.5358 19.8453 20.7857 18.3094 20.7857C16.917 20.7857 15.6785 20.7857 14.2856 20.7857V21.0952C14.2856 21.609 14.7016 22.0238 15.2142 22.0238H30.0712C30.3795 22.0238 30.6673 21.8709 30.8401 21.6158C31.0128 21.3608 31.0481 21.0364 30.9335 20.7504Z",
      fill: "#5EB24A"
    }, null, -1)
  ])))
}